var _filter;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513.683,
    height: 159.819,
    viewBox: "0 0 513.683 159.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9y4ns7og0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1681",
    transform: "translate(-24)",
    style: {
      fill: "none"
    },
    d: "M0 0h513.683v159.819H0z"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "go6qv82dna",
    x: 0,
    y: 0,
    width: 870,
    height: 870,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ebff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3627"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3626",
    style: {
      clipPath: "url(#9y4ns7og0a)"
    },
    transform: "translate(24)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 961",
    d: "M19.683 37.782 7.932 3.23H0V44.1h5.286V19.978q0-1.446-.083-4.521t-.084-4.577V9.629L16.9 44.1h5.486L34.051 9.629q0 3.311-.055 6.2t-.055 4.145V44.1h5.285V3.23h-7.875z",
    transform: "translate(0 -2.117)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 962",
    d: "M143.163 3.231 127.779 44.1h5.675l4.423-12.241h16.163l4.146 12.241h6.065L149.423 3.231zm-3.7 24.119 6.594-18.05 6.2 18.055z",
    transform: "translate(-83.764 -2.118)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 963",
    d: "M267.892 26.985a18.082 18.082 0 0 1-2.487 6.51 10.326 10.326 0 0 1-9.156 4.7q-6.53 0-9.824-4.469t-3.293-11.652q0-8.771 3.647-13.017a12.013 12.013 0 0 1 9.576-4.246q4.863 0 7.554 2.309a11.276 11.276 0 0 1 3.593 6.26h5.4a14.5 14.5 0 0 0-4.7-9.292Q263.963 0 256.292 0q-8.992 0-14.105 6.291-4.73 5.791-4.73 14.837 0 11.916 6.3 17.622a17 17 0 0 0 11.825 4.315q8.167 0 12.98-5.258a18.549 18.549 0 0 0 4.73-10.822z",
    transform: "translate(-155.663)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 964",
    d: "m414.43 376.658-11.74-34.8h-6.12l14.883 40.867h5.87l14.911-40.867h-6.2z",
    transform: "translate(-259.968 -224.101)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1679",
    transform: "translate(178.883 117.755)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h5.592v40.867H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 965",
    d: "M586.88 361.012a16.729 16.729 0 0 0-6.2-2.587l-5.553-1.308a34.762 34.762 0 0 1-7.2-2.226 4.7 4.7 0 0 1-2.426-4.4 6.572 6.572 0 0 1 2.053-4.785q2.054-2.058 6.749-2.058 5.814 0 8.242 3.2a10.525 10.525 0 0 1 1.707 5.035h5.2q0-6.816-4.372-9.918a17.89 17.89 0 0 0-10.626-3.1q-6.8 0-10.5 3.533a11.94 11.94 0 0 0-3.708 9.041 8.632 8.632 0 0 0 3.773 7.65 23.794 23.794 0 0 0 7.438 2.7l5.363 1.252a20.027 20.027 0 0 1 6.414 2.421q2.021 1.419 2.021 4.757 0 4.452-4.77 6.176a15.993 15.993 0 0 1-5.467.89q-6.7 0-9.352-4.061a11.479 11.479 0 0 1-1.581-5.647h-5.2q-.084 6.621 4.123 10.488 4.2 3.9 11.639 3.894a21.152 21.152 0 0 0 11.192-2.921q4.815-2.921 4.815-9.709 0-5.452-3.774-8.318",
    transform: "translate(-366.37 -222.142)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 966",
    d: "M701.4 367.116a15.223 15.223 0 0 1-1.374 7.039q-2.552 4.813-9.646 4.812-5.917 0-8.412-4.451a14.757 14.757 0 0 1-1.683-7.4v-25.26H674.7v22.951q0 7.54 2.038 11.6 3.712 7.4 14.1 7.4t14.125-7.4q2.038-4.062 2.038-11.6v-22.951H701.4z",
    transform: "translate(-442.29 -224.101)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 967",
    d: "m794.914 341.856-15.384 40.867h5.675l4.423-12.241h16.163l4.145 12.241H816l-14.828-40.867zm-3.7 24.119 6.593-18.055 6.2 18.055z",
    transform: "translate(-511.014 -224.101)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 968",
    d: "M908.279 341.856h-5.536v40.867h26.039v-4.869h-20.5z",
    transform: "translate(-591.785 -224.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1680",
    transform: "translate(343.816 117.755)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h5.592v40.867H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 969",
    d: "M1034.844 346.724h23.294l-25.13 31.409v4.59h32.271v-4.869H1040l25.28-31.241v-4.757h-30.435z",
    transform: "translate(-677.179 -224.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 970",
    d: "M1150.87 364h22.423v-4.729h-22.423v-12.408h24.259v-5.007h-29.656v40.867h30.073v-4.868h-24.676z",
    transform: "translate(-750.905 -224.101)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 971",
    d: "M1286.667 379.3a16.883 16.883 0 0 1-.39-3.478l-.194-5.48a9.191 9.191 0 0 0-1.35-5.147 8.36 8.36 0 0 0-3.6-2.56 10.053 10.053 0 0 0 5.759-9.765q0-7.038-5.655-9.653a18.234 18.234 0 0 0-7.567-1.363h-18.576v40.867h5.536V365.2h12.244a11.658 11.658 0 0 1 4.838.751q2.7 1.364 2.892 5.369l.334 6.816a26.033 26.033 0 0 0 .278 3.228 5.087 5.087 0 0 0 .445 1.363h6.788v-.918a3.421 3.421 0 0 1-1.781-2.5m-7.6-20.281a10.212 10.212 0 0 1-5.992 1.558h-12.445v-13.973h13.148a9.841 9.841 0 0 1 4.41.835q3.084 1.586 3.084 5.954 0 4.062-2.2 5.62",
    transform: "translate(-822.764 -224.101)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3628"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 972",
    d: "M809.756 194.725V180.55h26.78v-9.575h-26.78v-11.707h29.174v-9.762H798.5v11.334a20.5 20.5 0 0 0-5.724-7.426q-6.377-5.33-16.887-5.33-12.118 0-19.487 8.079-6.816 7.472-7.322 19.492l-9.26-26.149H726.8l-14.114 39.554v-39.555h-16.57l-9.949 43.35-10.024-43.35h-16.756v41.468L644.7 149.505h-13.014l-10.077 28.239a51.55 51.55 0 0 0 .043-2.02 42.758 42.758 0 0 0-1.052-9.124 24.537 24.537 0 0 0-3.927-8.9 18.2 18.2 0 0 0-9.388-6.994 28.979 28.979 0 0 0-8.528-1.2H575.01v55.132h23.75q9.685 0 15.458-6.184l-2.207 6.184h12.044l3.815-11.333h20.31l3.553 11.333h18.388v-37.29q0-1.608-.038-4.507t-.037-4.47l10.361 46.267h11.183l10.435-46.267q0 1.571-.037 4.47t-.037 4.507v37.29h17.219l3.815-11.333H743.3l3.553 11.333h12.492l-1.708-4.824a23.384 23.384 0 0 0 16.645 6.282 21.047 21.047 0 0 0 11.218-2.806 26.408 26.408 0 0 0 5.984-5.535l1.16 6.882h47.634v-9.912zm-201.57-7.7q-3.217 8.042-11.371 8.041h-10.622v-35.985h10.622q7.855 0 10.51 4.488 2.618 4.526 2.618 12.941a28.372 28.372 0 0 1-1.758 10.51m22.789-3.217 7.107-21.693 6.882 21.693zm95.115 0 7.111-21.693 6.882 21.693zm51.218-8.752v9.2h12.754a14.472 14.472 0 0 1-4.563 8.771 13.626 13.626 0 0 1-9.5 3.347 15.227 15.227 0 0 1-10.548-4.227q-4.638-4.227-4.638-14.4 0-10.1 4.282-15.129a13.728 13.728 0 0 1 10.941-5.031 15.707 15.707 0 0 1 6.321 1.234 10.8 10.8 0 0 1 6.4 7.892h9.744v8.341z",
    transform: "translate(-376.941 -97.075)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 973",
    d: "M74.193 183.505q0 5.8-1.373 8.469-2.137 4.73-9.269 4.73-7.172 0-9.308-4.73-1.373-2.67-1.373-8.469v-34.56H40.93v34.56a33.709 33.709 0 0 0 1.694 11.558H12.032v-46.118H.283v56.227h43.205v-8.134c.074.144.148.289.226.429q5.226 9.155 19.836 9.155t19.8-9.155q2.784-5 2.785-13.962v-34.56H74.193z",
    transform: "translate(-.186 -97.64)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 974",
    d: "M328.422 181.623h13.008a14.756 14.756 0 0 1-4.654 8.945 13.894 13.894 0 0 1-9.689 3.414 15.53 15.53 0 0 1-10.757-4.311q-4.73-4.31-4.73-14.686 0-10.3 4.368-15.43a14 14 0 0 1 11.158-5.131 16.022 16.022 0 0 1 6.447 1.259 11.011 11.011 0 0 1 6.523 8.049h11.558a20.214 20.214 0 0 0-7.458-13.561q-6.5-5.436-17.223-5.436-12.36 0-19.874 8.24c-.49.537-.949 1.1-1.392 1.67v-8.46h-10.948v39.252l-22.392-39.252h-12.321v56.227h10.948v-39.938l22.964 39.939h11.749v-7.763a24.66 24.66 0 0 0 1.315 1.507q7.132 7.744 18.31 7.744a21.468 21.468 0 0 0 11.444-2.861 26.937 26.937 0 0 0 6.1-5.646l1.183 7.019h7.782V172.24h-23.419z",
    transform: "translate(-170.471 -94.88)",
    style: {
      fill: "#8dfffb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3629",
    style: {
      filter: "url(#go6qv82dna)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 972",
    d: "M809.756 194.725V180.55h26.78v-9.575h-26.78v-11.707h29.174v-9.762H798.5v11.334a20.5 20.5 0 0 0-5.724-7.426q-6.377-5.33-16.887-5.33-12.118 0-19.487 8.079-6.816 7.472-7.322 19.492l-9.26-26.149H726.8l-14.114 39.554v-39.555h-16.57l-9.949 43.35-10.024-43.35h-16.756v41.468L644.7 149.505h-13.014l-10.077 28.239a51.55 51.55 0 0 0 .043-2.02 42.758 42.758 0 0 0-1.052-9.124 24.537 24.537 0 0 0-3.927-8.9 18.2 18.2 0 0 0-9.388-6.994 28.979 28.979 0 0 0-8.528-1.2H575.01v55.132h23.75q9.685 0 15.458-6.184l-2.207 6.184h12.044l3.815-11.333h20.31l3.553 11.333h18.388v-37.29q0-1.608-.038-4.507t-.037-4.47l10.361 46.267h11.183l10.435-46.267q0 1.571-.037 4.47t-.037 4.507v37.29h17.219l3.815-11.333H743.3l3.553 11.333h12.492l-1.708-4.824a23.384 23.384 0 0 0 16.645 6.282 21.047 21.047 0 0 0 11.218-2.806 26.408 26.408 0 0 0 5.984-5.535l1.16 6.882h47.634v-9.912zm-201.57-7.7q-3.217 8.042-11.371 8.041h-10.622v-35.985h10.622q7.855 0 10.51 4.488 2.618 4.526 2.618 12.941a28.372 28.372 0 0 1-1.758 10.51m22.789-3.217 7.107-21.693 6.882 21.693zm95.115 0 7.111-21.693 6.882 21.693zm51.218-8.752v9.2h12.754a14.472 14.472 0 0 1-4.563 8.771 13.626 13.626 0 0 1-9.5 3.347 15.227 15.227 0 0 1-10.548-4.227q-4.638-4.227-4.638-14.4 0-10.1 4.282-15.129a13.728 13.728 0 0 1 10.941-5.031 15.707 15.707 0 0 1 6.321 1.234 10.8 10.8 0 0 1 6.4 7.892h9.744v8.341z",
    transform: "translate(-376.941 -98.24)",
    style: {
      opacity: 0.674,
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 973",
    d: "M74.193 183.505q0 5.8-1.373 8.469-2.137 4.73-9.269 4.73-7.172 0-9.308-4.73-1.373-2.67-1.373-8.469v-34.56H40.93v34.56a33.709 33.709 0 0 0 1.694 11.558H12.032v-46.118H.283v56.227h43.205v-8.134c.074.144.148.289.226.429q5.226 9.155 19.836 9.155t19.8-9.155q2.784-5 2.785-13.962v-34.56H74.193z",
    transform: "translate(-.186 -98.805)",
    style: {
      opacity: 0.674,
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 974",
    d: "M328.422 181.623h13.008a14.756 14.756 0 0 1-4.654 8.945 13.894 13.894 0 0 1-9.689 3.414 15.53 15.53 0 0 1-10.757-4.311q-4.73-4.31-4.73-14.686 0-10.3 4.368-15.43a14 14 0 0 1 11.158-5.131 16.022 16.022 0 0 1 6.447 1.259 11.011 11.011 0 0 1 6.523 8.049h11.558a20.214 20.214 0 0 0-7.458-13.561q-6.5-5.436-17.223-5.436-12.36 0-19.874 8.24c-.49.537-.949 1.1-1.392 1.67v-8.46h-10.948v39.252l-22.392-39.252h-12.321v56.227h10.948v-39.938l22.964 39.939h11.749v-7.763a24.66 24.66 0 0 0 1.315 1.507q7.132 7.744 18.31 7.744a21.468 21.468 0 0 0 11.444-2.861 26.937 26.937 0 0 0 6.1-5.646l1.183 7.019h7.782V172.24h-23.419z",
    transform: "translate(-170.471 -96.045)",
    style: {
      opacity: 0.674,
      fill: "#8dfffb"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logo-large.2ffb12f27a206daa7f546c576d3e52ce.svg";
export { ForwardRef as ReactComponent };